// src/redux/thunks/ai/completegooglelocation.js

import { aiApi } from './ai';

export const completeGoogleLocationApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({

    completeGoogleLocation: builder.mutation({
      query: ({ sessionId, locationName }) => ({
        url:    '/social/oauth/google/complete-location',
        method: 'POST',
        body:   { sessionId, locationName },
      }),
      invalidatesTags: ['SocialAccount'],
    }),

  }),
  overrideExisting: false,
});

export const { useCompleteGoogleLocationMutation } = completeGoogleLocationApi;